import script from "./CollectedInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectedInfo.vue?vue&type=script&setup=true&lang=js"

import "./CollectedInfo.vue?vue&type=style&index=0&id=434e98ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434e98ba"]])

export default __exports__